import {Injectable, signal} from "@angular/core";
import {UserDto} from "@api-contracts";
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserStateService {
  showSideBar = signal(true);
  currentUser = signal<UserDto | undefined>(undefined);

  navbarButtonState = signal<'IDLE' | 'EDIT' | 'HIDDEN'>('HIDDEN');

  navbarButtonClickedSubject = new Subject<void>();

  navbarButtonClicked() {
    this.navbarButtonClickedSubject.next();
  }
}
